import { useEffect, useRef, useState } from "react";
import { getStrapiMedia } from "../../utils/utils";

interface VideoSliderItemProps {
  videoUrl: string;
  mimeType: string;
  isActive: boolean;
  isPreloaded?: boolean;
  priority?: boolean; // Новий проп для пріоритетного завантаження
}

const VideoSliderItem = ({
  videoUrl,
  mimeType,
  isActive,
  isPreloaded = false,
  priority = false,
}: VideoSliderItemProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMounted, setIsMounted] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(priority); // Для пріоритетного завантаження

  // Встановлюємо стан mounted для уникнення проблем з SSR
  useEffect(() => {
    setIsMounted(true);

    // Для не-пріоритетних слайдів - затримка перед завантаженням
    if (!priority) {
      const timer = setTimeout(() => {
        setShouldLoad(true);
      }, 1000); // Завантажуємо через 1 секунду після mount

      return () => clearTimeout(timer);
    }
  }, [priority]);

  // Контроль програвання відео
  useEffect(() => {
    if (!videoRef.current || !isMounted || !shouldLoad) return;

    const video = videoRef.current;

    if (isActive) {
      // Для активного слайду - програвати відео
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Video play failed:", error);
        });
      }
    } else {
      // Для неактивних слайдів - ставити на паузу
      video.pause();
    }
  }, [isActive, isMounted, shouldLoad]);

  // Оптимізація завантаження - не рендерити відео на сервері
  if (!isMounted) {
    return (
      <div className="slider__media">
        <div className="video-placeholder">{/* Placeholder для SSR */}</div>
      </div>
    );
  }

  // Для не-пріоритетних слайдів показуємо placeholder доки не готові завантажити
  if (!shouldLoad) {
    return (
      <div className="slider__media">
        <div className="video-placeholder loading">
          <div className="loading-indicator">Завантаження...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="slider__media">
      <video
        ref={videoRef}
        autoPlay={isActive}
        loop
        muted
        playsInline
        preload={isPreloaded ? "metadata" : "metadata"}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      >
        <source src={getStrapiMedia(videoUrl)} type={mimeType} />
      </video>
    </div>
  );
};

export default VideoSliderItem;
